import {
  CASHBACK, CASHBACK_SUMMARY, CASHBACK_SUMMARY_PAGINATE, CASHBACK_SUMMARY_PARAMS, CASHBACK_CREATE,
  CASHBACK_RESCUE, CASHBACK_RESCUE_PAGINATE, CASHBACK_RESCUE_PARAMS, CASHBACK_SUMMARY_QUERY,
  CASHBACK_RESCUES_UPDATE, CASHBACK_RESCUE_QUERY, NOTIFICATIONS_INCLUDE
} from '@store/types'
import shortly from 'vuex-shortly'
import graphQL from '@graphQL'
import CashbackQuery from '@graphQL/queries/CashbackTransactions'
import CashbackRescueQuery from '@graphQL/queries/CashbackRescue'
import axios from 'axios'
import { cleanObj } from '@/helpers/cleanObj'

const state = {
  list: [],
  cashback: {},
  details: {},
  paginate: {},
  params: {
    search: ''
  }
}

const getters = {
  [CASHBACK]: 'cashback',
  [CASHBACK_SUMMARY]: 'list',
  [CASHBACK_SUMMARY_PAGINATE]: 'paginate',
  [CASHBACK_SUMMARY_PARAMS]: 'params',
  [CASHBACK_RESCUE]: 'list',
  [CASHBACK_RESCUE_PAGINATE]: 'paginate',
  [CASHBACK_RESCUE_PARAMS]: 'params'
}

const mutations = {
  [CASHBACK]: 'cashback',
  [CASHBACK_SUMMARY]: 'list',
  [CASHBACK_SUMMARY_PAGINATE]: 'paginate',
  [CASHBACK_SUMMARY_QUERY]: (state, payload) => {
    state.params.search = payload
  },
  [CASHBACK_RESCUE]: 'list',
  [CASHBACK_RESCUE_PAGINATE]: 'paginate',
  [CASHBACK_RESCUE_QUERY]: (state, payload) => {
    state.params.search = payload
  }
}

const actions = {
  [CASHBACK_CREATE]: async ({ dispatch }, payload) => {
    try {
      const { id } = payload
      const method = id ? 'put' : 'post'

      const response = await axios[method](`/cashback${id ? '/' + id : ''}`, cleanObj(payload))

      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: `Cashback ${method === 'put' ? 'alterado' : 'criado'} com sucesso!`
      })

      dispatch(CASHBACK_SUMMARY)

      return response
    } catch (err) {
      dispatch(NOTIFICATIONS_INCLUDE, Error('Ocorreu um erro!'))
    }
  },
  [CASHBACK_SUMMARY]: async ({ commit, dispatch }, payload = {}) => {
    if (payload.period) {
      payload.end_date = payload.period.end
      payload.start_date = payload.period.start
    }
    const { period, ...data } = payload
    try {
      const response = await graphQL(CashbackQuery, data)
      const { data: cashbackTransactions, ...paginate } = response?.data?.data?.cashbackTransactions || {}
      commit(CASHBACK_SUMMARY, cashbackTransactions || [])
      commit(CASHBACK_SUMMARY_PAGINATE, paginate || {})
    } catch (err) {
      dispatch(NOTIFICATIONS_INCLUDE, Error('Ocorreu um erro!'))
    }
  },
  [CASHBACK_RESCUE]: async ({ commit, dispatch }, payload = {}) => {
    if (payload.period) {
      payload.end_date = payload.period.end
      payload.start_date = payload.period.start
    }
    try {
      const response = await graphQL(CashbackRescueQuery, payload)
      const { data: cashbackRescue, ...paginate } = response?.data?.data?.cashbackRescue || {}
      commit(CASHBACK_RESCUE, cashbackRescue)
      commit(CASHBACK_RESCUE_PAGINATE, paginate)
    } catch (err) {
      dispatch(NOTIFICATIONS_INCLUDE, Error('Ocorreu um erro!'))
    }
  },

  [CASHBACK_RESCUES_UPDATE]: async ({ dispatch }, cashback_id) => {
    try {
      const response = await axios.put(`/cashback-rescue/${cashback_id}`)
      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'Resgate alterado com sucesso!'
      })

      dispatch(CASHBACK_RESCUE)

      return response
    } catch (err) {
      dispatch(NOTIFICATIONS_INCLUDE, Error('Não foi possível alterar o resgate'))
    }
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/cashback.js